import React, { useEffect, useState } from 'react';
import LanguagesDropdown from '../../../components/LanguagesDropdown';
import {
    Alert,
    AlertTitle,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import {
    DESCRIPTION_DEATIL_INITIAL_STATE,
    ENGLISH_CONTENT_LANGUAGE_ID,
    GAELIC_CONTENT_LANGUAGE_ID,
} from '../../../../../utils/property/propertyUtils';
import {
    useProperty,
    usePropertyComplementaryData,
    usePropertyDescriptionDetail,
    usePropertyFetching,
} from '../../../../contextsProperty/ContextProperties';
import Card from '../../../../../muiComponents/Card';
import Menu from '../../../components/Menu';
import Flag from '../../../components/Flag';
import NewDescriptionPanel from './NewDescriptionPanel';
import useTranslate from '../../../../../customHooks/useTranslate';
import DeletePopUp from '../../DeletePopUp';
import { getRandomNumber } from '../../../../../utils/usefulFunctions';
import Button from '../../../../../muiComponents/Button';
import LoadingTab from '../../LoadingTab';
import Title from '../../Title';

const DescriptionsComponent = () => {
    const translate = useTranslate();
    const { descriptions, modidyCollectionItem } = useProperty();
    const { handleDescriptionDetailChange, getAIDescription } =
        usePropertyDescriptionDetail();
    const { languagesList } = usePropertyComplementaryData();
    const { isFetching } = usePropertyFetching();

    const [remainingLanguages, setRemainingLanguages] = useState([]);
    const [enabledDescriptions, setEnabledDescriptions] = useState([]);
    const [idDeletePopUpVisible, setIdDeletePopUpVisible] = useState('');

    useEffect(() => {
        if (descriptions.length && languagesList.length) {
            const filteredDescriptions = descriptions?.filter(
                description =>
                    !description.Deleted &&
                    description.idLanguage !== GAELIC_CONTENT_LANGUAGE_ID
            );

            const englishDesc = filteredDescriptions.find(
                item => item.idLanguage === ENGLISH_CONTENT_LANGUAGE_ID
            );
            const sortedDescriptions = filteredDescriptions.filter(
                item => item.idLanguage !== ENGLISH_CONTENT_LANGUAGE_ID
            );
            const englishFirst = englishDesc
                ? [englishDesc, ...sortedDescriptions]
                : sortedDescriptions;
            setEnabledDescriptions(englishFirst);
        }

        const availableLanguages = languagesList.filter(
            avaLanguage =>
                !descriptions.find(
                    item => item.idLanguage === parseInt(avaLanguage.id)
                ) ||
                descriptions.find(
                    item =>
                        item.idLanguage === parseInt(avaLanguage.id) &&
                        item.Deleted
                )
        );
        setRemainingLanguages(availableLanguages);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [descriptions, languagesList]);

    const handleOpenDescriptionPanel = async selectedLanguage => {
        handleDescriptionDetailChange({
            ...DESCRIPTION_DEATIL_INITIAL_STATE,
            id: `-${getRandomNumber(1, 9999)}`,
            idLanguage: parseInt(selectedLanguage.id),
            languageCode: selectedLanguage.cultureId,
            language: selectedLanguage.name,
            isOpenPanel: true,
        });
    };

    if (isFetching) {
        return <LoadingTab />;
    }

    return (
        <main className='property-description__content'>
            <div>
                <Title
                    as='h1'
                    text={'description_title'}
                    className='text-align-center'
                />
            </div>
            <div className='flex flex-end gap-20'>
                {/* <SearchBar placeholder='search' value='' onChange={() => {}} /> */}
                <LanguagesDropdown
                    languages={remainingLanguages}
                    handleAddDescription={handleOpenDescriptionPanel}
                />
            </div>

            {!enabledDescriptions.length ? (
                <Card className='padding20'>
                    <Alert
                        severity='info'
                        sx={{
                            alignItems: 'center',
                        }}
                        action={
                            <div
                                className='flex flex-align-center gap-10 margin-inline10 cursor-pointer'
                                onClick={() => {
                                    const englishLang = languagesList.find(
                                        lang =>
                                            parseInt(lang.id) ===
                                            ENGLISH_CONTENT_LANGUAGE_ID
                                    );
                                    handleDescriptionDetailChange({
                                        ...DESCRIPTION_DEATIL_INITIAL_STATE,
                                        id: `-${getRandomNumber(1, 9999)}`,
                                        idLanguage: parseInt(
                                            ENGLISH_CONTENT_LANGUAGE_ID
                                        ),
                                        languageCode:
                                            englishLang.cultureId || 'en',
                                        language: englishLang.name || 'English',
                                        isOpenPanel: true,
                                    });
                                }}
                            >
                                <Button variant='text' startIcon='Add'>
                                    {translate('add_description')}
                                </Button>
                            </div>
                        }
                    >
                        <div className=' width100perc'>
                            <AlertTitle sx={{ fontWeight: 'bold' }}>
                                {translate(
                                    'description_required_english_title'
                                )}
                            </AlertTitle>
                            <p style={{ fontWeight: 'normal' }}>
                                {translate(
                                    'description_required_english_subtitle'
                                )}
                            </p>
                        </div>
                    </Alert>
                </Card>
            ) : (
                <Card className='overflow-y-auto'>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell
                                    style={{ textTransform: 'capitalize' }}
                                >
                                    {translate('language')}
                                </TableCell>
                                <TableCell>
                                    {translate('description2')}
                                </TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {enabledDescriptions.map(description => {
                                return (
                                    <TableRow key={description.idLanguage}>
                                        <TableCell
                                            sx={{ verticalAlign: 'text-top' }}
                                        >
                                            <Flag
                                                code={description.languageCode}
                                                text={description.language}
                                            />
                                        </TableCell>
                                        <TableCell
                                            sx={{ verticalAlign: 'text-top' }}
                                        >
                                            {description.language}
                                        </TableCell>
                                        <TableCell className='text-preline'>
                                            {description.descriptionContent}
                                        </TableCell>
                                        <TableCell
                                            sx={{ verticalAlign: 'text-top' }}
                                        >
                                            <Menu
                                                menuItems={[
                                                    {
                                                        text: 'edit',
                                                        icon: 'Edit',
                                                        onClick: () => {
                                                            handleDescriptionDetailChange(
                                                                {
                                                                    id: description.id,
                                                                    idLanguage:
                                                                        description.idLanguage,
                                                                    languageCode:
                                                                        description.languageCode,
                                                                    language:
                                                                        description.language,
                                                                    descriptionContent:
                                                                        description.descriptionContent,
                                                                    isOpenPanel: true,
                                                                }
                                                            );
                                                        },
                                                    },
                                                    {
                                                        text: 'edit_AI_description',
                                                        icon: 'AutoFixHigh',
                                                        onClick: () => {
                                                            handleDescriptionDetailChange(
                                                                {
                                                                    id: description.id,
                                                                    idLanguage:
                                                                        description.idLanguage,
                                                                    languageCode:
                                                                        description.languageCode,
                                                                    language:
                                                                        description.language,
                                                                    descriptionContent:
                                                                        description.descriptionContent,
                                                                    isOpenPanel: true,
                                                                }
                                                            );
                                                            getAIDescription(
                                                                description.language
                                                            );
                                                        },
                                                    },
                                                    {
                                                        text: 'delete',
                                                        icon: 'Delete',
                                                        onClick: () => {
                                                            setIdDeletePopUpVisible(
                                                                description.id
                                                            );
                                                        },
                                                    },
                                                ]}
                                            />
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>

                        <></>
                    </Table>
                </Card>
            )}
            <NewDescriptionPanel />
            {idDeletePopUpVisible && (
                <DeletePopUp
                    open={!!idDeletePopUpVisible}
                    onSave={() => {
                        modidyCollectionItem('descriptions', 'delete', {
                            id: idDeletePopUpVisible,
                        });
                        setIdDeletePopUpVisible('');
                    }}
                    onCancel={() => {
                        setIdDeletePopUpVisible('');
                    }}
                />
            )}
        </main>
    );
};

export default DescriptionsComponent;
